// AddOrder.js
import React, { useState } from "react";
import {
  Container,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button,
  Box,
  Select,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,  Checkbox,        // ✅ إذا تستخدم checklist
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { sendNotification } from "./utils/sendNotification";
import { apiFetch, API_BASE } from "./utils/apiClient";
import InvoiceModal from "./InvoiceModal";
import { v4 as uuidv4 } from "uuid";
import { useLocation } from "react-router-dom";
import { isBoxAccount } from "./utils/userProfile";

function AddOrder() {
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
const [invoiceData, setInvoiceData] = useState(null);
// 🧾 صورة الفاتورة المعتمدة (تجي من صفحة الفاتورة) - تنعرض تلقائياً بواجهة برهان
const [invoiceImageUrl, setInvoiceImageUrl] = useState("");
// 📄 ملف PDF كامل للفاتورة (صورة الفاتورة + صفحة تفاصيل وصورة لكل لوحة) - يظهر بواجهة برهان
const [invoicePdfUrl, setInvoicePdfUrl] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [governorate, setGovernorate] = useState("");
  const [price, setPrice] = useState("");
  // ✅ طريقة الدفع
const [paymentMethod, setPaymentMethod] = useState(""); 
// القيم: "full_online" | "deposit" | "cash_on_delivery"

const [paymentProvider, setPaymentProvider] = useState(""); 
// ✅ صور / ملفات حوالة الدفع الأونلاين
const [paymentReceiptFiles, setPaymentReceiptFiles] = useState([]);
// القيم: "Qi Card" | "Zain Cash" | "FIB"

const [depositAmount, setDepositAmount] = useState(""); // رقم فقط

  const [orderType, setOrderType] = useState("");
const [priority, setPriority] = useState("");
const [drawingBoardsCount, setDrawingBoardsCount] = useState("");
// ✅ جديد: نوع الإدخال
const [requestKind, setRequestKind] = useState("new"); // "new" | "direct"
// ✅ للبيع المباشر فقط
const [saleAccount, setSaleAccount] = useState("بيع"); 
// بيع | حساب استاذ مروان | حساب نرسي | ماركتنك
// 🟦 بوب أب صور التركيب (مع تركيب)
const [assemblyDialogOpen, setAssemblyDialogOpen] = useState(false);
const [assemblyImages, setAssemblyImages] = useState([]);
// 🟦 صور برهان (عام - تظهر بواجهة برهان مع الطلب)
const [burhanImages, setBurhanImages] = useState([]);
const location = useLocation();
React.useEffect(() => {
  if (location.state?.fromInvoice) {
    const data = location.state;

    setCustomerName(data.customerName || "");
    setGovernorate(data.governorate || "");

    setPrice(
      data.price ? Number(data.price).toLocaleString("en-US") : ""
    );

    setNote(data.note || "");
    setBoardsCount(data.boardsCount || "");
    setSaleAccount(data.saleAccount || "بيع");

    // ✅ نخليه طلب جديد
    setRequestKind("new");
  }
}, [location.state]);
  const [https, setHttps] = useState("");
  const [source, setSource] = useState("");
  const [socialMediaSource, setSocialMediaSource] = useState("");
  const [withAssembly, setWithAssembly] = useState(null);
  const [withDrawing, setWithDrawing] = useState(null);
  const [note, setNote] = useState("");
  const [designerNote, setDesignerNote] = useState("");
  const [printNote, setPrintNote] = useState("");
  const [frameNote, setFrameNote] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [halimaOpen, setHalimaOpen] = useState(false);
  const [halimaNote, setHalimaNote] = useState("");
  const [halimaImages, setHalimaImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [halimaImageUrls, setHalimaImageUrls] = useState([]);
const [isSubmitting, setIsSubmitting] = useState(false);
// كان ماله استخدام سابقاً (orderId الحقيقي كان يجي من addDoc مباشرة) - صار
// يُستخدم كمعرّف مجلد Storage مؤقت (Phase 05C) لأن رفع الصور لازم يصير قبل
// معرفة orderId الحقيقي الآن (الإنشاء صار نداء باك اند واحد ذري - Phase 05B).
// يُجدَّد بعد كل إرسال ناجح حتى ما يشترك طلبين متتاليين بنفس مجلد Storage.
const [tempId, setTempId] = useState(uuidv4());
const [maythamCommission, setMaythamCommission] = useState("");
const [otherCustomerType, setOtherCustomerType] = useState("");
const [boardsCount, setBoardsCount] = useState("");
// ✅ Checklist الموظفات (Mandatory قبل الإرسال)
const staffChecklistItems = [
  "بلغت الزبون بوجود لوكو",
  "اخذت دفعة مقدمة",
  "شوفت التصميم النهائي بعد التعديل",
  "بلغت اللوحة طباعة فقط وليست رسم",
];

const [staffChecklist, setStaffChecklist] = useState(
  staffChecklistItems.reduce((acc, item) => {
    acc[item] = false;
    return acc;
  }, {})
);

const isStaffChecklistComplete = Object.values(staffChecklist).every(Boolean);

// 🟦 بوب أب خاص بصور اللوحة المرسلة للزبون
const [sentDialogOpen, setSentDialogOpen] = useState(false);
const [sentImages, setSentImages] = useState([]);
// 🖼️ صور الموكاب الخاصة بالزبون - Mandatory
const [mockupImages, setMockupImages] = useState([]);
const [customerPhone, setCustomerPhone] = useState("");
// 🤝 خصم الشريك (ست سارة) جاي من الفاتورة - { source, percent, amount } أو null
const [partnerDiscount, setPartnerDiscount] = useState(null);
// 🔵 تعبئة البيانات إذا جاي من الزبائن المحتملين
React.useEffect(() => {
  if (location.state?.fromInvoice) {
    const data = location.state;

    setCustomerName(data.customerName || "");
    setGovernorate(data.governorate || "");

    setPrice(
      data.price ? Number(data.price).toLocaleString("en-US") : ""
    );

    setNote(data.note || "");
    setBoardsCount(data.boardsCount || "");
    setSaleAccount(data.saleAccount || "بيع");

    setInvoiceData(data.invoiceData || null);
    setInvoiceImageUrl(data.invoiceImageUrl || "");
    setInvoicePdfUrl(data.invoicePdfUrl || "");

    // 💳 تعبئة طريقة الدفع والدفعة الأولية تلقائياً من الفاتورة
    const invoicePaymentMethodMap = {
      cod: "cash_on_delivery",
      partial: "deposit",
      full: "full_online",
    };
    const mappedPaymentMethod =
      invoicePaymentMethodMap[data.invoicePaymentMethod] || "";
    setPaymentMethod(mappedPaymentMethod);

    if (mappedPaymentMethod === "deposit" && data.invoiceAdvancePayment) {
      setDepositAmount(
        Number(data.invoiceAdvancePayment).toLocaleString("en-US")
      );
    }

    // 🤝 فاتورة جاية من "طلب جديد" مال ارت تاتش - المصدر ورقم الزبون
    // يتعبّون تلقائياً حتى الطلب يظهر بداشبورد ارت تاتش بعد الإنشاء
    if (data.partnerSource === "ارت تاتش") {
      setSource("ارت تاتش");
      setCustomerPhone(data.customerPhone || "");
    }

    // 🤝 فاتورة بخصم شريك (ست سارة) - المصدر يتعبّى تلقائياً، والخصم
    // (المحسوب بالفاتورة على اللوحات فقط) ينحفظ ويا الطلب
    if (data.partnerDiscountSource === "ست سارة") {
      setSource(data.partnerDiscountSource);
      setPartnerDiscount({
        source: data.partnerDiscountSource,
        percent: Number(data.partnerDiscountPercent) || 0,
        amount: Number(data.partnerDiscountAmount) || 0,
      });
    } else {
      setPartnerDiscount(null);
    }

    setRequestKind("new");
  }
}, [location.state]);

  const username = localStorage.getItem("username");
  // ✅ employee (اسم الموظفة العربي) صار يُشتق من التوكن بالباك اند (Phase
  // 05B) بنفس خريطة username الموجودة هنا سابقاً - لم نعد نحسبه أو نرسله
  // من الفرونت إطلاقاً.
      const STAFF_USERS_REQUIRE_INVOICE = [
  "rand@123",
  "jumana@123",
  "sara@123",
  "Baneen@123",
  "karina@123",
  "maryam@123",
  "farah@123",
  "maysa@123",
];

// + حسابات البوكسات (الجديدة مثل تيهان) نفس موظفات المبيعات
const mustCreateInvoiceFirst = STAFF_USERS_REQUIRE_INVOICE.includes(username) || isBoxAccount();

const cameFromInvoice = location.state?.fromInvoice === true;

const invoiceGateBlocked = mustCreateInvoiceFirst && !cameFromInvoice;
  const governorates = [
    "بغداد", "البصرة", "نينوى", "الأنبار", "ديالى", "كركوك", "واسط",
    "ميسان", "ذي قار", "بابل", "كربلاء", "النجف", "الديوانية",
    "المثنى", "صلاح الدين", "دهوك", "أربيل", "السليمانية"
  ];

  const handlePriceChange = (e) => {
    const val = e.target.value.replace(/,/g, "");
    if (/^\d*$/.test(val)) {
      const formatted = Number(val).toLocaleString("en-US");
      setPrice(formatted);
    }
  };
const handleDepositChange = (e) => {
  const val = e.target.value.replace(/,/g, "");
  if (/^\d*$/.test(val)) {
    const formatted = val ? Number(val).toLocaleString("en-US") : "";
    setDepositAmount(formatted);
  }
};
// ✅ منطق قيد المحاسبة (المحفظة/الموقع/شرط الإنشاء/المبلغ المدفوع) صار
// يُحسب بالكامل بالباك اند (Phase 05B، نفس الشروط حرفياً) - لم نعد نحتاج
// هذي الدوال بالفرونت إطلاقاً.


const uploadPaymentReceipts = async (orderId) => {
  const urls = [];

  for (const file of paymentReceiptFiles) {
    const safeFileName = file.name.replace(/[^\w.\-ء-ي ]/g, "_");
    const fileRef = ref(
      storage,
      `paymentReceipts/${orderId}/${Date.now()}-${safeFileName}`
    );

    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);
    urls.push(url);
  }

  return urls;
};

const uploadMockupImages = async (orderId) => {
  const urls = [];

  for (const file of mockupImages) {
    const safeFileName = file.name.replace(/[^\w.\-ء-ي ]/g, "_");

    const fileRef = ref(
      storage,
      `mockups/${orderId}/${Date.now()}-${safeFileName}`
    );

    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);

    urls.push(url);
  }

  return urls;
};
const handleSubmit = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  if (invoiceGateBlocked) {
    alert("⚠️ لازم تسوين الفاتورة من سستم الفواتير أولاً، وبعدها ترجعين لإضافة الطلب من صفحة الفاتورة.");
    return;
  }

  setIsSubmitting(true);
if (!isStaffChecklistComplete) {
  alert("⚠️ لازم تكملي Checklist قبل إرسال الطلب.");
  setIsSubmitting(false);
  return;
}
// ✅ منع إرسال الطلب إذا ما مرفوعة صور الموكاب
if (mockupImages.length === 0) {
  alert("⚠️ يجب رفع صورة أو عدة صور للموكاب قبل إرسال الطلب.");
  setIsSubmitting(false);
  return;
}
// ✅ منع إرسال الطلب إذا مع تركيب وماكو صور تركيب
if (withAssembly === true && assemblyImages.length === 0) {
  alert("⚠️ اخترت (مع تركيب) لازم ترفع صور التركيب قبل إرسال الطلب.");
  setIsSubmitting(false);
  return;
}
// ✅ منع إرسال الطلب إذا ما مرفوعة صور لبرهان
if (burhanImages.length === 0) {
  alert("⚠️ يجب رفع صورة أو عدة صور للورشة قبل إرسال الطلب.");
  setIsSubmitting(false);
  return;
}

  try {
if (withDrawing === true && halimaImageUrls.length === 0) {
  alert("🔔 اخترت 'مع رسم' — لازم ترفع صور وملاحظات من البوب أب قبل إرسال الطلب.");
  setIsSubmitting(false);
  return;
}
// منع إرسال الطلب إذا لم يتم رفع صور اللوحة المرسلة للزبون
if (
  requestKind === "new" &&   // ✅ فقط للطلب الجديد
  (username === "rand@123" ||
    username === "admin@123" ||
    username === "jumana@123" ||
    username === "sara@123" ||
    username === "karina@123" ||
    username === "maryam@123" ||
    username === "farah@123" ||
    username === "maysa@123" ||
    username === "Baneen@123" || isBoxAccount()) &&
  sentImages.length === 0
) {
  alert("⚠️ يجب رفع صور اللوحة المرسلة للزبون قبل إرسال الطلب.");
  setIsSubmitting(false);
  return;
}

if (!boardsCount || Number(boardsCount) <= 0) {
  alert("⚠️ يرجى إدخال عدد اللوحات الكلي بشكل صحيح");
  setIsSubmitting(false);
  return;
}
if (withDrawing === true && (!drawingBoardsCount || Number(drawingBoardsCount) <= 0)) {
  alert("⚠️ يرجى إدخال عدد لوحات الرسم بشكل صحيح");
  setIsSubmitting(false);
  return;
}
if (withDrawing === true && Number(drawingBoardsCount) > Number(boardsCount)) {
  alert("⚠️ عدد لوحات الرسم يجب أن يكون مساوياً أو أقل من عدد اللوحات الكلي");
  setIsSubmitting(false);
  return;
}

if (requestKind === "new" && !priority) {
  alert("⚠️ يرجى اختيار مستوى الأولوية");
  setIsSubmitting(false);
  return;
}

// ✅ قواعد البيع المباشر فقط
if (requestKind === "direct") {
  if (!customerName || !governorate || !orderType || !price || !https|| !source || withAssembly === null || withDrawing === null) {
    alert("يرجى ملء جميع الحقول واختيار خيارات التركيب والرسم والمصدر");
    setIsSubmitting(false);
    return;
  }


  // ✅ البيع المباشر ما يحتاج رابط ولا أولوية
}

if (requestKind === "new" && (!customerName || !governorate || !orderType || !price || !https || !source || withAssembly === null || withDrawing === null)) {
      alert("يرجى ملء جميع الحقول واختيار خيارات التركيب والرسم والمصدر");
      return;
    }

    if (source === "ميثم برحيه" && !maythamCommission) {
  alert("يرجى اختيار النسبة المئوية الخاصة بميثم برحيه");
  setIsSubmitting(false);
  return;
}
if (source === "سوشال ميديا" && !socialMediaSource) {
  alert("⚠️ يرجى اختيار مصدر السوشال ميديا: Facebook أو Instagram أو WhatsApp");
  setIsSubmitting(false);
  return;
}
// ✅ orderType النهائي (تحويل "other_company"+otherCustomerType) وstatus
// الابتدائي صارا يُحسبان بالباك اند الآن (Phase 05B) - نرسل orderType/
// otherCustomerType/requestKind/withDrawing الخام فقط بالـpayload تحت

const hidePayment = ["ماركتنك", "حساب نرسي", "حساب استاذ مروان", "مطبعة صدى سومر - أبو زينب (زبون)"].includes(saleAccount);
if (!hidePayment && !paymentMethod) {
  alert("⚠️ يرجى اختيار طريقة الدفع");
  setIsSubmitting(false);
  return;
}

if (paymentMethod === "full_online" && !paymentProvider) {
  alert("⚠️ يرجى اختيار وسيلة الدفع (Qi Card / Zain Cash / FIB)");
  setIsSubmitting(false);
  return;
}

if (paymentMethod === "deposit" || paymentMethod === "deposit_cash") {
  if (!depositAmount || Number(depositAmount.replace(/,/g, "")) <= 0) {
    alert("⚠️ يرجى إدخال قيمة الدفعة الأولية بشكل صحيح");
    setIsSubmitting(false);
    return;
  }
}
if (paymentMethod === "deposit" && !paymentProvider) {
  alert("⚠️ يرجى اختيار وسيلة الدفع");
  setIsSubmitting(false);
  return;
}
if (
  (paymentMethod === "deposit" ||
    paymentMethod === "deposit_cash" ||
    paymentMethod === "full_online" ||
    paymentMethod === "full_cash") &&
  paymentReceiptFiles.length === 0
) {
  alert("⚠️ يرجى رفع صورة وصل الدفعة");
  setIsSubmitting(false);
  return;
}
// 🖼️ رفع كل الصور المرتبطة بالطلب أولاً - نفس مسارات Storage بالضبط، فقط
// بـ tempId بدل orderId (orderId الحقيقي ما يصير معروف إلا بعد نجاح
// POST /api/orders الآن، لأن الإنشاء صار نداء باك اند واحد ذري - Phase 05B)
let mockupUrls = [];
if (mockupImages.length > 0) {
  mockupUrls = await uploadMockupImages(tempId);
}

let paymentReceiptUrls = [];
if (
  (paymentMethod === "deposit" ||
    paymentMethod === "deposit_cash" ||
    paymentMethod === "full_online" ||
    paymentMethod === "full_cash") &&
  paymentReceiptFiles.length > 0
) {
  paymentReceiptUrls = await uploadPaymentReceipts(tempId);
}

let assemblyUrls = [];
if (withAssembly === true && assemblyImages.length > 0) {
  for (const file of assemblyImages) {
    const fileId = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `assemblyBoards/${tempId}/images/${fileId}`);

    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    assemblyUrls.push(url);
  }
}

let burhanUrls = [];
if (burhanImages.length > 0) {
  for (const file of burhanImages) {
    const fileId = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `burhanImages/${tempId}/${fileId}`);

    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    burhanUrls.push(url);
  }
}

let sentUrls = [];
if (
    requestKind === "new" &&  // ✅ فقط للطلب الجديد

  (username === "rand@123" ||
    username === "admin@123" ||
    username === "jumana@123" ||
    username === "sara@123" ||
      username === "maryam@123" ||
      username === "farah@123" ||
      username === "karina@123" ||
      username === "maysa@123" ||
    username === "Baneen@123" || isBoxAccount()) &&
  sentImages.length > 0
) {
  for (const file of sentImages) {
    const fileId = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `compareBoards/${tempId}/sentToCustomer/${fileId}`);

    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);

    sentUrls.push(url);
  }
}

await sendNotification(
  "designer@123", // 🔹 المستخدم اللي راح توصله الإشعارات
  "طلب جديد   🎨",
  `تم إرسال طلب ${customerName} إلى المصمم`
);

// 📦 حمولة واحدة لـ POST /api/orders (Phase 05C) - الباك اند يحسب
// status/employee/createdAt/history/accountingEntryId بنفسه (Phase 05B)،
// ويكتب orders/accounting_pro/halimaTemp-أو-halimaRequests/invoices/leads
// بدفعة Firestore واحدة ذرية بدل الكتابات المنفصلة القديمة (whitelist مطابق
// تماماً لتقرير Phase 05B - لا نرسل status/employee/createdAt/history/
// accountingEntryId/accountingEntryCreated/id/orderId إطلاقاً)
const payload = {
  customerName,
  governorate,
  saleAccount,
  price: Number(price.replace(/,/g, "")),
  boardsCount: Number(boardsCount),
  orderType,
  otherCustomerType,
  https,
  source,
  socialMediaSource,
  customerPhone,
  withAssembly,
  withDrawing,
  drawingBoardsCount: withDrawing ? Number(drawingBoardsCount) : undefined,
  requestKind,
  priority,
  note,
  designerNote,
  printNote,
  frameNote,
  maythamCommission,
  // 🤝 خصم الشريك - فقط إذا المصدر بقى نفس شريك الفاتورة
  ...(partnerDiscount && source === partnerDiscount.source
    ? {
        partnerDiscountPercent: partnerDiscount.percent,
        partnerDiscountAmount: partnerDiscount.amount,
      }
    : {}),
  staffChecklist,
  paymentMethod,
  paymentProvider,
  depositAmount:
    paymentMethod === "deposit" || paymentMethod === "deposit_cash"
      ? Number(depositAmount.replace(/,/g, ""))
      : undefined,
  mockupImages: mockupUrls,
  burhanImages: burhanUrls,
  assemblyImages: assemblyUrls,
  sentToCustomerImages: sentUrls,
  paymentReceiptUrls,
  halimaNote,
  halimaImageUrls,
  invoiceData: invoiceData || undefined,
  leadId:
    location.state?.fromLead && location.state?.leadId
      ? location.state.leadId
      : undefined,
  invoiceImageUrl: invoiceImageUrl || undefined,
  invoicePdfUrl: invoicePdfUrl || undefined,
};

const res = await apiFetch(`${API_BASE}/orders`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

const responseData = await res.json().catch(() => ({}));

if (!res.ok) {
  alert(`⚠️ ${responseData.error || "حدث خطأ أثناء إرسال الطلب"}`);
  setIsSubmitting(false);
  return;
}

// 🔁 مجلد Storage التالي لازم يكون مختلف حتى ما يشترك طلبين متتاليين
// (بدون إعادة تحميل الصفحة) بنفس مسار الصور
setTempId(uuidv4());

    setSuccessOpen(true);
setStaffChecklist(
  staffChecklistItems.reduce((acc, item) => {
    acc[item] = false;
    return acc;
  }, {})
);


    setCustomerName("");
    setGovernorate("");
    setSaleAccount("");

    setPrice("");
    setPaymentMethod("");
setPaymentProvider("");
setDepositAmount("");

    setOrderType("");
    setHttps("");
    setSource("");
    setPartnerDiscount(null);
    setSocialMediaSource("");
    setWithAssembly(null);
    setWithDrawing(null);
    setHalimaNote("");
setHalimaImages([]);
setHalimaImageUrls([]);   // ✅ مهم جداً
setDrawingBoardsCount("");

     setNote("");
     setDesignerNote("");
     setPrintNote("");
     setFrameNote("");
     setSentImages([]);
     setAssemblyImages([]);
     setMockupImages([]);
     setBurhanImages([]);
  // 🧹 تفريغ الصور بعد الإرسال
setBoardsCount("");
setPriority("");       // ✅ تفريغ الأولوية

  } catch (err) {
    console.error("submit error:", err);
    alert("حدث خطأ أثناء إرسال الطلب");
  } finally {
    setIsSubmitting(false);    // أهم سطر يمنع بقاء اللودينغ
  }
};

const handleUploadToHalima = async () => {
  if (!customerName || !governorate) {
    alert("يرجى إدخال اسم الزبون والمحافظة أولاً");
    return;
  }
    if (!halimaNote.trim()) {
    alert("⚠️ يجب إدخال ملاحظة للرسام قبل الإرسال");
    return;
  }
  if (halimaImages.length === 0) {
    alert("يرجى رفع صورة واحدة على الأقل");
    return;
  }

  setUploading(true);
  try {
    const urls = [];
    for (const image of halimaImages) {
      const storageRef = ref(storage, `halima/${Date.now()}-${image.name}`);
      await uploadBytes(storageRef, image);
      const url = await getDownloadURL(storageRef);
      urls.push(url);
    }
    setHalimaImageUrls(urls);           // ✅ خزن الروابط محلياً
    setSnackbarOpen(true);              // إشعار نجاح
    setHalimaOpen(false);               // أغلق البوب أب
  } catch (error) {
    console.error("❌ فشل رفع صور الرسام:", error);
    alert("❌ حدث خطأ أثناء رفع الصور. الرجاء المحاولة مرة أخرى.");
  } finally {
    setUploading(false);
  }
};


  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>📝 إضافة طلب جديد</Typography>
        {invoiceGateBlocked && (
  <Alert severity="warning" sx={{ mb: 2 }}>
    ⚠️ لا يمكن إضافة طلب مباشرة من هذه الصفحة. يجب إنشاء الفاتورة أولاً من سستم الفواتير، وبعدها يتم تحويلك تلقائياً إلى إضافة الطلب.
  </Alert>
)}
        <Box component="form" onSubmit={handleSubmit}>
          <FormControl component="fieldset" sx={{ mb: 2 }}>
  <Typography sx={{ mb: 1 }}>نوع الإدخال</Typography>
  <RadioGroup
    row
    value={requestKind}
 onChange={(e) => {
  const v = e.target.value;
  setRequestKind(v);

  // ❌ إذا جاي من فاتورة لا تمسح البيانات
  if (!location.state?.fromInvoice) {
    setCustomerName("");
    setGovernorate("");
    setSaleAccount("");

    setPrice("");
    setPaymentMethod("");
    setPaymentProvider("");
    setDepositAmount("");
setPaymentReceiptFiles([]);
    setOrderType("");
    setSource("");
    setSocialMediaSource("");
    setNote("");
    setDesignerNote("");
    setPrintNote("");
    setFrameNote("");
    setBoardsCount("");
    setWithAssembly(null);
    setWithDrawing(null);
    setDrawingBoardsCount("");
    setHalimaNote("");
    setHalimaImages([]);
    setHalimaImageUrls([]);
    setSentImages([]);
    setBurhanImages([]);
    setCustomerPhone("");
    setMaythamCommission("");
    setPartnerDiscount(null);
    setOtherCustomerType("");
    setInvoiceData(null);

    if (v === "direct") {
      setHttps("");
      setPriority("");
    }
  }
}}
>  
    <FormControlLabel value="new" control={<Radio />} label="طلب جديد" />
    <FormControlLabel value="direct" control={<Radio />} label="بيع مباشر" />
  </RadioGroup>
</FormControl>

          <TextField fullWidth label="اسم الزبون" value={customerName} onChange={(e) => setCustomerName(e.target.value)} sx={{ mb: 2 }} required />
          <FormControl fullWidth sx={{ mb: 2 }} required>
            <InputLabel>المحافظة</InputLabel>
            
            <Select value={governorate} onChange={(e) => setGovernorate(e.target.value)} label="المحافظة">
            
              {governorates.map((gov) => (<MenuItem key={gov} value={gov}>{gov}</MenuItem>))}
            </Select>
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 2 }} required>
  <InputLabel>حساب البيع</InputLabel>
  <Select
    value={saleAccount}
    label="حساب البيع"
    onChange={(e) => setSaleAccount(e.target.value)}
  >
    <MenuItem value="بيع">بيع</MenuItem>
    <MenuItem value="حساب استاذ مروان">حساب استاذ مروان</MenuItem>
    <MenuItem value="حساب نرسي">حساب نرسي</MenuItem>
    <MenuItem value="مطبعة صدى سومر - أبو زينب (زبون)">مطبعة صدى سومر - أبو زينب (زبون)</MenuItem>
    <MenuItem value="ماركتنك">ماركتنك</MenuItem>
  </Select>
</FormControl>

          <TextField fullWidth label="السعر (دينار عراقي)" value={price} onChange={handlePriceChange} sx={{ mb: 2 }} required inputProps={{ inputMode: "numeric" }} />
          {/* ✅ طريقة الدفع */}
          {!["ماركتنك", "حساب نرسي", "حساب استاذ مروان", "مطبعة صدى سومر - أبو زينب (زبون)"].includes(saleAccount) && (
<FormControl fullWidth sx={{ mb: 2 }} required>
  <InputLabel>طريقة الدفع</InputLabel>
  <Select
    value={paymentMethod}
    label="طريقة الدفع"
   onChange={(e) => {
  const v = e.target.value;
  setPaymentMethod(v);

  // ✅ تنظيف عند التبديل
  setPaymentProvider("");
  setDepositAmount("");
  setPaymentReceiptFiles([]);
}}
  >
<MenuItem value="cash_on_delivery">🚚 دفع عند الاستلام</MenuItem>
    <MenuItem value="deposit">💰 دفع اونلاين دفعة اولية</MenuItem>
  <MenuItem value="deposit_cash"> دفعة اولية كاش</MenuItem>
    <MenuItem value="full_online">💳 دفع المبلغ كامل اون لاين</MenuItem>
  <MenuItem value="full_cash">💵 دفعة كاملة كاش</MenuItem>
  </Select>
</FormControl>
)}
{/* ✅ إذا دفع كامل اون لاين */}
{/* ✅ إذا دفع كامل اون لاين */}
{paymentMethod === "full_online" && (
  <FormControl fullWidth sx={{ mb: 2 }} required>
    <InputLabel>وسيلة الدفع</InputLabel>
    <Select
      value={paymentProvider}
      label="وسيلة الدفع"
      onChange={(e) => setPaymentProvider(e.target.value)}
    >
      <MenuItem value="Qi Card">Qi Card</MenuItem>
      <MenuItem value="Zain Cash">Zain Cash</MenuItem>
      <MenuItem value="FIB">FIB</MenuItem>
    </Select>
  </FormControl>
)}

{/* ✅ إذا دفعة أولية */}
{(paymentMethod === "deposit" || paymentMethod === "deposit_cash") && (
  <>
    <TextField
      fullWidth
      label="قيمة الدفعة الأولية"
      value={depositAmount}
      onChange={handleDepositChange}
      sx={{ mb: 2 }}
      required
    />

    {paymentMethod === "deposit" && (
      <FormControl fullWidth sx={{ mb: 2 }} required>
        <InputLabel>وسيلة الدفع</InputLabel>
        <Select
          value={paymentProvider}
          label="وسيلة الدفع"
          onChange={(e) => setPaymentProvider(e.target.value)}
        >
          <MenuItem value="Qi Card">Qi Card</MenuItem>
          <MenuItem value="Zain Cash">Zain Cash</MenuItem>
          <MenuItem value="FIB">FIB</MenuItem>
        </Select>
      </FormControl>
    )}
  </>
)}

{/* ✅ رفع صورة / صور الحوالة للدفع الأونلاين */}
{/* ✅ رفع صورة / صور وصل الدفعة */}
{(
  paymentMethod === "deposit_cash" ||
  paymentMethod === "full_cash" ||
  ((paymentMethod === "deposit" || paymentMethod === "full_online") && paymentProvider)
) && (  <Box sx={{ mb: 2 }}>
    <Button variant="outlined" component="label" fullWidth>
      {paymentReceiptFiles.length > 0
        ? `✅ تم اختيار ${paymentReceiptFiles.length} صورة / ملف للحوالة`
       : "📎 رفع صورة / صور وصل الدفعة"}
      <input
        hidden
        multiple
        type="file"
        accept="image/*,.pdf"
        onChange={(e) =>
          setPaymentReceiptFiles((prev) => [...prev, ...Array.from(e.target.files || [])])
        }
      />
    </Button>

    {paymentReceiptFiles.length > 0 && (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
        }}
      >
        {paymentReceiptFiles.map((file, index) => {
          const isImage = file.type?.startsWith("image/");
          const fileUrl = URL.createObjectURL(file);

          return (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: "110px",
                height: "110px",
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid #ddd",
                background: "#f5f5f5",
              }}
            >
              {isImage ? (
                <img
                  src={fileUrl}
                  alt={`payment-receipt-${index}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Typography
                  fontSize={12}
                  color="text.secondary"
                  sx={{ p: 1, wordBreak: "break-word" }}
                >
                  📄 {file.name}
                </Typography>
              )}

              <Button
                size="small"
                color="error"
                sx={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  minWidth: 24,
                  height: 24,
                  borderRadius: "50%",
                  p: 0,
                  background: "#fff",
                }}
                onClick={() =>
                  setPaymentReceiptFiles((prev) =>
                    prev.filter((_, i) => i !== index)
                  )
                }
              >
                ✕
              </Button>
            </Box>
          );
        })}
      </Box>
    )}
  </Box>
)}

         {/* ✅ عدد اللوحات – نفس تنسيق باقي الحقول */}


<TextField
  fullWidth
  label="عدد اللوحات الكلي"
  type="number"
  value={boardsCount}
  onChange={(e) => setBoardsCount(e.target.value)}
  sx={{ mb: 2 }}
  required
  inputProps={{
    min: 1,
    step: 1,
  }}
/>
<FormControl fullWidth sx={{ mb: 2 }} required>
  <InputLabel>نوع الزبون</InputLabel>
  <Select
    value={orderType}
    label="نوع الزبون"
    onChange={(e) => {
      setOrderType(e.target.value);
      setOtherCustomerType(""); // تصفير النص عند التغيير
    }}
  >
    <MenuItem value="project_hotel">مشروع - فندق</MenuItem>
    <MenuItem value="project_restaurant">مشروع - مطعم</MenuItem>
    <MenuItem value="project_cafe">مشروع - كافيه</MenuItem>
    <MenuItem value="project_salon">مشروع - صالون</MenuItem>
    <MenuItem value="project_clinic">مشروع - عيادة</MenuItem>
<MenuItem value="project_beauty_center">مشروع - مركز تجميل</MenuItem>
<MenuItem value="project_hospital">مشروع - مستشفى</MenuItem>

    <MenuItem value="engineer_designer">مهندس أو مصمم</MenuItem>
    <MenuItem value="engineering_company">
      شركة هندسية أو شركة تصميم داخلي
    </MenuItem>

    <MenuItem value="other_company">شركات أخرى</MenuItem>

    <MenuItem value="apartment">شقة</MenuItem>
    <MenuItem value="house">بيت</MenuItem>
    <MenuItem value="influencer">
  انفلونسر / بلوكر / مشهور
</MenuItem>
<MenuItem value="furniture_company">شركة اثاث</MenuItem>
  </Select>
</FormControl>
{orderType === "other_company" && (
  <TextField
    fullWidth
    label="اذكر نوع الزبون"
    value={otherCustomerType}
    onChange={(e) => setOtherCustomerType(e.target.value)}
    sx={{ mb: 2 }}
    required
  />
)}


          <FormControl fullWidth sx={{ mb: 2 }} required>
            <InputLabel>من أين أتى الطلب؟</InputLabel>
           <Select
  value={source}
  onChange={(e) => {
    const value = e.target.value;
    setSource(value);

    if (value !== "سوشال ميديا") {
      setSocialMediaSource("");
    }
  }}
  label="من أين أتى الطلب؟"
>

              <MenuItem value="سوشال ميديا">سوشال ميديا</MenuItem>
              <MenuItem value="مجمع البروج - صروح A">مجمع البروج - صروح A</MenuItem>
              <MenuItem value="مجمع البروج - صروح D">مجمع البروج - صروح D</MenuItem>
              <MenuItem value="مجمع النسيم">مجمع النسيم</MenuItem>
              <MenuItem value="الريف كافيه - بغداد">الريف كافيه - بغداد</MenuItem>
              <MenuItem value="الريف كافيه - اربيل">الريف كافيه - اربيل</MenuItem>
              <MenuItem value="ارت تاتش">ارت تاتش</MenuItem>
              <MenuItem value="علاقات ومعارف">علاقات ومعارف</MenuItem>
<MenuItem value="ميثم برحيه">علاقات ومعارف – ميثم برحيه</MenuItem>
              <MenuItem value=" نواف"> علاقات ومعارف – نواف</MenuItem>
<MenuItem value="ست سارة">ست سارة</MenuItem>

            </Select>
          </FormControl>
          {source === "سوشال ميديا" && (
  <FormControl fullWidth sx={{ mb: 2 }} required>
    <InputLabel>مصدر السوشال ميديا</InputLabel>
    <Select
      value={socialMediaSource}
      label="مصدر السوشال ميديا"
      onChange={(e) => setSocialMediaSource(e.target.value)}
    >
      <MenuItem value="Facebook">Facebook</MenuItem>
      <MenuItem value="Instagram">Instagram</MenuItem>
      <MenuItem value="WhatsApp">WhatsApp</MenuItem>
    </Select>
  </FormControl>
)}
{source === "ارت تاتش" && (
  <TextField
    fullWidth
    label="رقم الزبون (خاص بارت تاتش)"
    value={customerPhone}
    onChange={(e) => setCustomerPhone(e.target.value)}
    sx={{ mb: 2 }}
    required
  />
)}
{source === "ميثم برحيه" && (

  <TextField
    fullWidth
    label="رقم الزبون ( ميثم برحيه   )"
    value={customerPhone}
    onChange={(e) => setCustomerPhone(e.target.value)}
    sx={{ mb: 2 }}
    required
  />
)}
{source === "ميثم برحيه" && (
  <FormControl fullWidth sx={{ mb: 2 }} required>
    <InputLabel>النسبة المئوية</InputLabel>
    <Select
      value={maythamCommission}
      label="النسبة المئوية"
      onChange={(e) => setMaythamCommission(e.target.value)}
    >
      <MenuItem value={5}>5%</MenuItem>
      <MenuItem value={10}>10%</MenuItem>
      <MenuItem value={15}>15%</MenuItem>
      <MenuItem value={20}>20%</MenuItem>
    </Select>
  </FormControl>
)}
{partnerDiscount && source === partnerDiscount.source && (
  <Alert severity="info" sx={{ mb: 2 }}>
    خصم {partnerDiscount.source} {partnerDiscount.percent}% على اللوحات (
    {partnerDiscount.amount.toLocaleString()} د.ع) - محسوب من الفاتورة
  </Alert>
)}

{requestKind === "new" && (
  <FormControl fullWidth sx={{ mb: 2 }} required>
    <InputLabel>مستوى الأولوية</InputLabel>
    <Select
      value={priority}
      label="مستوى الأولوية"
      onChange={(e) => setPriority(e.target.value)}
    >
      <MenuItem value="Low">🟢 Low</MenuItem>
      <MenuItem value="Medium">🟡 Medium</MenuItem>
      <MenuItem value="High">🔴 High</MenuItem>
    </Select>
  </FormControl>
)}



  <TextField
    fullWidth
    label="رابط Google Drive"
    value={https}
    onChange={(e) => setHttps(e.target.value)}
    sx={{ mb: 2 }}
    required
  />
  {/* 🖼️ ترتيب واجهة الطلب: 1) صورة المرسلة للزبون 2) الموكاب 3) الورشة 4) الرسم 5) التركيب */}

{/* زر خاص برند وجمانا لرفع صور اللوحة المرسلة للزبون */}
{/* زر خاص برفع صور اللوحة المرسلة للزبون (إجباري) */}
{requestKind === "new" && (   // ✅ فقط للطلب الجديد
  (username === "rand@123" ||
    username === "admin@123" ||
    username === "jumana@123" ||
    username === "sara@123" ||
    username === "maryam@123" ||
    username === "farah@123" ||
    username === "karina@123" ||
    username === "maysa@123" ||
    username === "Baneen@123" || isBoxAccount())
) && (
  <Box sx={{ mb: 2 }}>
    <Button
      variant="outlined"
      fullWidth
      onClick={() => setSentDialogOpen(true)}
    >
      📤 رفع صور اللوحة المرسلة للزبون (إجباري)
    </Button>

    {sentImages.length > 0 && (
      <Typography sx={{ mt: 1 }} fontSize={13} color="green">
        ✅ تم اختيار {sentImages.length} صورة للوحة المرسلة للزبون
      </Typography>
    )}

    {sentImages.length > 0 && (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
        }}
      >
        {sentImages.map((file, index) => {
          const imageUrl = URL.createObjectURL(file);

          return (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: "110px",
                height: "110px",
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid #ddd",
                background: "#f5f5f5",
              }}
            >
              <img
                src={imageUrl}
                alt={`sent-${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />

              <Button
                size="small"
                color="error"
                sx={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  minWidth: 24,
                  height: 24,
                  borderRadius: "50%",
                  p: 0,
                  background: "#fff",
                }}
                onClick={() =>
                  setSentImages((prev) =>
                    prev.filter((_, i) => i !== index)
                  )
                }
              >
                ✕
              </Button>
            </Box>
          );
        })}
      </Box>
    )}
  </Box>
)}

  {/* 🖼️ رفع صور الموكاب - إجباري */}
<Box sx={{ mb: 2 }}>
  <Typography fontWeight={700} sx={{ mb: 1 }}>
    🖼️ صور الموكاب المرسلة للزبون <span style={{ color: "red" }}>*</span>
  </Typography>

  <Button variant="outlined" component="label" fullWidth>
    {mockupImages.length > 0
      ? `✅ تم اختيار ${mockupImages.length} صورة موكاب`
      : "📤 رفع صورة / صور الموكاب"}
    <input
      hidden
      multiple
      type="file"
      accept="image/*"
      onChange={(e) => setMockupImages((prev) => [...prev, ...Array.from(e.target.files || [])])}
    />
  </Button>

  {mockupImages.length === 0 && (
    <Typography fontSize={13} color="error" sx={{ mt: 1 }}>
      ⚠️ هذا الحقل إجباري، يجب رفع صورة واحدة على الأقل.
    </Typography>
  )}

  {mockupImages.length > 0 && (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        mt: 2,
      }}
    >
      {mockupImages.map((file, index) => {
        const imageUrl = URL.createObjectURL(file);

        return (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: "110px",
              height: "110px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #ddd",
              background: "#f5f5f5",
            }}
          >
            <img
              src={imageUrl}
              alt={`mockup-${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />

            <Button
              size="small"
              color="error"
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                minWidth: 24,
                height: 24,
                borderRadius: "50%",
                p: 0,
                background: "#fff",
              }}
              onClick={() =>
                setMockupImages((prev) =>
                  prev.filter((_, i) => i !== index)
                )
              }
            >
              ✕
            </Button>
          </Box>
        );
      })}
    </Box>
  )}
</Box>

{/* 🖼️ رفع صور للورشة - إجباري - تظهر ويا الطلب بواجهة برهان */}
<Box sx={{ mb: 2 }}>
  <Typography fontWeight={700} sx={{ mb: 1 }}>
    🖼️ صور للورشة <span style={{ color: "red" }}>*</span>
  </Typography>

  <Button variant="outlined" component="label" fullWidth>
    {burhanImages.length > 0
      ? `✅ تم اختيار ${burhanImages.length} صورة للورشة`
      : "📤 رفع صورة / صور للورشة"}
    <input
      hidden
      multiple
      type="file"
      accept="image/*"
      onChange={(e) => setBurhanImages((prev) => [...prev, ...Array.from(e.target.files || [])])}
    />
  </Button>

  {burhanImages.length === 0 && (
    <Typography fontSize={13} color="error" sx={{ mt: 1 }}>
      ⚠️ هذا الحقل إجباري، يجب رفع صورة واحدة على الأقل.
    </Typography>
  )}

  {burhanImages.length > 0 && (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        mt: 2,
      }}
    >
      {burhanImages.map((file, index) => {
        const imageUrl = URL.createObjectURL(file);

        return (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: "110px",
              height: "110px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #ddd",
              background: "#f5f5f5",
            }}
          >
            <img
              src={imageUrl}
              alt={`burhan-${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />

            <Button
              size="small"
              color="error"
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                minWidth: 24,
                height: 24,
                borderRadius: "50%",
                p: 0,
                background: "#fff",
              }}
              onClick={() =>
                setBurhanImages((prev) =>
                  prev.filter((_, i) => i !== index)
                )
              }
            >
              ✕
            </Button>
          </Box>
        );
      })}
    </Box>
  )}
</Box>

          <FormControl component="fieldset" sx={{ mb: 1, display: "block", width: "100%" }}>
            <Typography sx={{ mb: 1 }}>🎨 هل يتطلب رسم؟</Typography>
            <RadioGroup
              row
              value={withDrawing}
              onChange={(e) => {
                const val = e.target.value === "true";
                setWithDrawing(val);
                if (val) setHalimaOpen(true);
              }}
            >
              <FormControlLabel value="true" control={<Radio />} label="مع رسم" />
              <FormControlLabel value="false" control={<Radio />} label="بدون رسم" />
            </RadioGroup>
          </FormControl>
            {withDrawing === true && (
  <TextField
    fullWidth
    label="عدد لوحات الرسم"
    type="number"
    value={drawingBoardsCount}
    onChange={(e) => setDrawingBoardsCount(e.target.value)}
    sx={{ mb: 2 }}
    required
    inputProps={{
      min: 1,
      step: 1,
    }}
  />
)}

{withDrawing === true && (
  <Box sx={{ mb: 2 }}>
    <Button variant="outlined" fullWidth onClick={() => setHalimaOpen(true)}>
      {halimaImageUrls.length > 0
        ? `✅ تم اختيار ${halimaImageUrls.length} صورة للرسم — تعديل`
        : "📤 رفع صور الرسم"}
    </Button>

    {halimaImageUrls.length === 0 && (
      <Typography fontSize={13} color="error" sx={{ mt: 1 }}>
        ⚠️ هذا الحقل إجباري، يجب رفع صورة واحدة على الأقل.
      </Typography>
    )}

    {halimaImageUrls.length > 0 && (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
        {halimaImageUrls.map((url, index) => (
          <Box
            key={index}
            sx={{
              width: "110px",
              height: "110px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #ddd",
              background: "#f5f5f5",
            }}
          >
            <img
              src={url}
              alt={`drawing-${index}`}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
        ))}
      </Box>
    )}
  </Box>
)}

          <FormControl component="fieldset" sx={{ mb: 1, display: "block", width: "100%" }}>
            <Typography sx={{ mb: 1 }}>⚙️ هل يتطلب تركيب؟</Typography>
           <RadioGroup
  row
  value={withAssembly}
  onChange={(e) => {
    const val = e.target.value === "true";
    setWithAssembly(val);

    // ✅ إذا اختار مع تركيب افتح البوب اب
 if (val) {
  setAssemblyDialogOpen(true);
} else {
  setAssemblyImages([]);
  setAssemblyDialogOpen(false);
}

  }}
>
  <FormControlLabel value="true" control={<Radio />} label="مع تركيب" />
  <FormControlLabel value="false" control={<Radio />} label="بدون تركيب" />
</RadioGroup>

          </FormControl>

{withAssembly === true && (
  <Box sx={{ mb: 2 }}>
    <Button variant="outlined" fullWidth onClick={() => setAssemblyDialogOpen(true)}>
      {assemblyImages.length > 0
        ? `✅ تم اختيار ${assemblyImages.length} صورة للتركيب — تعديل`
        : "📤 رفع صور التركيب"}
    </Button>

    {assemblyImages.length === 0 && (
      <Typography fontSize={13} color="error" sx={{ mt: 1 }}>
        ⚠️ هذا الحقل إجباري، يجب رفع صورة واحدة على الأقل.
      </Typography>
    )}

    {assemblyImages.length > 0 && (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
        {assemblyImages.map((file, index) => {
          const imageUrl = URL.createObjectURL(file);
          return (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: "110px",
                height: "110px",
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid #ddd",
                background: "#f5f5f5",
              }}
            >
              <img
                src={imageUrl}
                alt={`assembly-${index}`}
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
              <Button
                size="small"
                color="error"
                sx={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  minWidth: 24,
                  height: 24,
                  borderRadius: "50%",
                  p: 0,
                  background: "#fff",
                }}
                onClick={() =>
                  setAssemblyImages((prev) => prev.filter((_, i) => i !== index))
                }
              >
                ✕
              </Button>
            </Box>
          );
        })}
      </Box>
    )}
  </Box>
)}

          <TextField fullWidth label="ملاحظات للمصمم (اختياري)" value={designerNote} onChange={(e) => setDesignerNote(e.target.value)} sx={{ mb: 2 }} multiline rows={2} />
          <TextField fullWidth label="ملاحظات للمطبعة (اختياري)" value={printNote} onChange={(e) => setPrintNote(e.target.value)} sx={{ mb: 2 }} multiline rows={2} />
          <TextField fullWidth label="ملاحظات للإطارات (اختياري)" value={frameNote} onChange={(e) => setFrameNote(e.target.value)} sx={{ mb: 2 }} multiline rows={2} />
          <TextField fullWidth label="ملاحظات (اختياري)" value={note} onChange={(e) => setNote(e.target.value)} sx={{ mb: 3 }} multiline rows={2} />
  


<Box sx={{ mb: 2, p: 2, border: "1px solid #ddd", borderRadius: 2 }}>
  <Typography fontWeight={700} sx={{ mb: 1 }}>
    ✅ Checklist (إجباري قبل الإرسال)
  </Typography>

  {staffChecklistItems.map((item) => (
    <FormControlLabel
      key={item}
      sx={{ display: "flex" }}
      control={
        <Checkbox
          checked={!!staffChecklist[item]}
          onChange={(e) =>
            setStaffChecklist((prev) => ({
              ...prev,
              [item]: e.target.checked,
            }))
          }
        />
      }
      label={item}
    />
  ))}

  {!isStaffChecklistComplete && (
    <Typography color="error" fontSize={13} sx={{ mt: 1 }}>
      ⚠️ لازم تأشرين على كل الخيارات قبل إرسال الطلب.
    </Typography>
  )}
</Box>

<Button
  type="submit"
  variant="contained"
  fullWidth
   disabled={isSubmitting || invoiceGateBlocked}
  startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : null}
>
  {isSubmitting
    ? "جاري الإرسال..."
    : invoiceGateBlocked
    ? "يجب إنشاء الفاتورة أولاً"
    : "إرسال الطلب"}
</Button>
        </Box>
      </Paper>

      <Dialog open={halimaOpen} onClose={() => setHalimaOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
        ملاحظات للرسام
          <IconButton
            aria-label="close"
            onClick={() => setHalimaOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
        <TextField
  fullWidth
  label="ملاحظات "
  value={halimaNote}
  onChange={(e) => setHalimaNote(e.target.value)}
  multiline
  rows={3}
  sx={{ mb: 2 }}
  required
/>

          <Button variant="outlined" component="label" sx={{ mb: 2 }}>
            📤رفع صور اللوحات للرسم
            <input
              hidden
              multiple
              type="file"
              accept="image/*"
              onChange={(e) => setHalimaImages((prev) => [...prev, ...Array.from(e.target.files || [])])}
            />
          </Button>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {halimaImages.map((file, index) => {
              const imageUrl = URL.createObjectURL(file);

              return (
                <Box
                  key={index}
                  sx={{
                    position: "relative",
                    width: "110px",
                    height: "110px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #ddd",
                    background: "#f5f5f5",
                  }}
                >
                  <img
                    src={imageUrl}
                    alt={`halima-${index}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />

                  <Button
                    size="small"
                    color="error"
                    sx={{
                      position: "absolute",
                      top: 2,
                      right: 2,
                      minWidth: 24,
                      height: 24,
                      borderRadius: "50%",
                      p: 0,
                      background: "#fff",
                    }}
                    onClick={() =>
                      setHalimaImages((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                  >
                    ✕
                  </Button>
                </Box>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleUploadToHalima}
            disabled={uploading}
            variant="contained"
            startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {uploading ? "جاري الإرسال..." : "📨 إرسال  "}
          </Button>
        </DialogActions>
      </Dialog>
{/* بوب أب صور اللوحة المرسلة للزبون (رند / جمانا) */}
<Dialog
  open={sentDialogOpen}
  onClose={() => setSentDialogOpen(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    صور اللوحة المرسلة للزبون
    <IconButton
      aria-label="close"
      onClick={() => setSentDialogOpen(false)}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <Typography sx={{ mb: 2 }}>
      📌 قم برفع جميع الصور التي تم إرسالها للزبون (يمكن اختيار أكثر من صورة).
    </Typography>

    <Button variant="outlined" component="label" sx={{ mb: 2 }}>
      📤 اختيار صور
      <input
        hidden
        multiple
        type="file"
        accept="image/*"
        onChange={(e) => setSentImages((prev) => [...prev, ...Array.from(e.target.files || [])])}
      />
    </Button>

   <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    mt: 2,
  }}
>
  {sentImages.map((file, index) => {
    const imageUrl = URL.createObjectURL(file);
    return (
      <Box
        key={index}
        sx={{
          width: "120px",
          height: "120px",
          borderRadius: "8px",
          overflow: "hidden",
          border: "1px solid #ddd",
        }}
      >
        <img
          src={imageUrl}
          alt={`sent-preview-${index}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            background: "#f5f5f5",
          }}
        />
      </Box>
    );
  })}
</Box>


    {sentImages.length === 0 && (
      <Typography fontSize={13} color="error">
        * يجب اختيار صورة واحدة على الأقل قبل إرسال الطلب.
      </Typography>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setSentDialogOpen(false)} variant="contained">
      ✅ حفظ اللوحات
    </Button>
  </DialogActions>
</Dialog>
{/* 🟦 بوب أب صور التركيب (مع تركيب) */}
<Dialog
  open={assemblyDialogOpen}
  onClose={() => setAssemblyDialogOpen(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    صور مواقع تركيب اللوحات و قياسات التثبيت
    <IconButton
      aria-label="close"
      onClick={() => setAssemblyDialogOpen(false)}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <Typography sx={{ mb: 2 }}>
      يرجى إرفاق صورة واضحة لكل موقع تركيب، مع تحديد قياسات التثبيت على الصورة، بما يشمل الارتفاع عن الأرض أو الأثاث، والمسافة عن السقف وحواف الجدار، والمسافات بين اللوحات إن كان المطلوب تركيب اكثر من لوحة على نفس الجدار.
      <br />
      <br />
      هذه الصور ستظهر فقط في واجهة الورشة
    </Typography>

    <Button variant="outlined" component="label" sx={{ mb: 2 }}>
      📤 اختيار صور
      <input
        hidden
        multiple
        type="file"
        accept="image/*"
        onChange={(e) => setAssemblyImages((prev) => [...prev, ...Array.from(e.target.files || [])])}
      />
    </Button>

    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
      {assemblyImages.map((file, index) => {
        const imageUrl = URL.createObjectURL(file);
        return (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: "120px",
              height: "120px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #ddd",
            }}
          >
            <img
              src={imageUrl}
              alt={`assembly-preview-${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                background: "#f5f5f5",
              }}
            />

            <Button
              size="small"
              color="error"
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                minWidth: 24,
                height: 24,
                borderRadius: "50%",
                p: 0,
                background: "#fff",
              }}
              onClick={() =>
                setAssemblyImages((prev) =>
                  prev.filter((_, i) => i !== index)
                )
              }
            >
              ✕
            </Button>
          </Box>
        );
      })}
    </Box>

    {assemblyImages.length === 0 && (
      <Typography fontSize={13} color="error" sx={{ mt: 2 }}>
        ⚠️ إذا اخترت (مع تركيب) لازم ترفع صورة واحدة على الأقل.
      </Typography>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setAssemblyDialogOpen(false)} variant="contained">
      ✅ حفظ صور التركيب
    </Button>
  </DialogActions>
</Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
       <Alert severity="info" variant="filled">
  ⏳ تم حفظ بيانات الرسم بانتظار موافقة الورشة!
</Alert>

      </Snackbar>

      <Snackbar
        open={successOpen}
        autoHideDuration={3000}
        onClose={() => setSuccessOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" variant="filled">
✅ تم إرسال الطلب بنجاح!
        </Alert>
      </Snackbar>
      <InvoiceModal
  isOpen={isInvoiceOpen}
  onClose={() => setIsInvoiceOpen(false)}
  onSave={(data) => setInvoiceData(data)}
  existingData={invoiceData}
/>
    </Container>
    
  );
}


export default AddOrder;
